/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import ApplicationAdapter from '../application';

export default ApplicationAdapter.extend({
  pathForType() {
    return 'usage_reminders/current_usage';
  },
});
